import { render, staticRenderFns } from "./ModalAddTask.vue?vue&type=template&id=cacc84fe&"
import script from "./ModalAddTask.vue?vue&type=script&lang=js&"
export * from "./ModalAddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports